import {Button, Col, Modal, Row, Table, Switch} from "antd";
import {Scatter, Column} from '@ant-design/plots';
import {useEffect, useLayoutEffect, useState} from "react";
import {useSelector} from "react-redux";
import api from "./store/api"
import {useTranslation} from "react-i18next";

const StatisticModal = (props) => {
    const {t} = useTranslation(['common', 'valid'])
    const {isStatisticVisible, setIsStatisticVisible, selectedRows, stateFuncType} = props;
    const [selectedButton, setSelectedButton] = useState("1")
    const [isScatterOrTable, setIsScatterOrTable] = useState(true)
    const coefficient = 1000
    const code = t('common:code')
    const tooltip = {
        crosshairs: {
            type: 'cross'
        },
        fields: [code, "Стоимость", "Наименование"],
        customContent: (title, items) => {
            let htmlStr = `<div class="g2-tooltip-items g2-tooltip-items-table" >`;
            items.forEach((item) => {
                htmlStr += `<div class="g2-tooltip-item g2-tooltip-item-table-row" >
                <span class="g2-tooltip-item-label g2-tooltip-item-label-table-cell">${item.name}:</span>
                <span class="g2-tooltip-item-value g2-tooltip-item-value-table-cell">${item.value}</span>
              </div>`;
            });
            htmlStr += '</div>';
            return htmlStr;
        },
    };
    const onReady = (plot) => {
        plot.on('element:click', (param) => {
            window.open(`./project/${param.data.data.id}`, "_blank", "noreferrer");
        });
    }

    const [Sconfig1, setScofig1] = useState({
        appendPadding: 30,
        height: 120,
        data: [],
        xField: 'Стоимость',
        yField: 'change_in_yRate',
        onReady: onReady,
        tooltip: tooltip,
        size: [4],
        shape: 'circle',
        pointStyle: {
            fillOpacity: 0.8,
            stroke: '#bbb',
        },
        xAxis: {
            min: -25,
            max: 5,
            grid: {
                line: {
                    style: {
                        display: 'none',
                        stroke: '#eee',
                    },
                },
            },
            line: {
                style: {
                    display: 'none',
                    // stroke: '#aaa',
                },
            },
        },
        yAxis: {
            visible: false,
            min: 0,
            max: 1,
            grid: null,
            //     {
            //     line: {
            //         style: {
            //             display: 'none',
            //             stroke: '#aaa',
            //         },
            //     },
            // }
        },
    });


    const [Sconfig2, setSconfig2] = useState({
        data: [],
        xField: 'object',
        yField: 'Стоимость',
        groupField: "object",
        isGroup: true,
        onReady: onReady,
        label: {
            position: 'top',
            // 'top', 'bottom', 'middle',
            style: {
                fill: '#FFFFFF',
                opacity: 0.6,
            },
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
        tooltip: tooltip,
    })


    const [buildingData, setBuildingData] = useState([
        {
            key: '1',
            name: 'м2 общей площади здания'
        },
        {
            key: '2',
            name: 'м2 полезной площади здания'
        },
        // {
        //     key: '3',
        //     name: 'м2 общей площади квартир'
        // },
        // {
        //     key: '4',
        //     name: 'м2 полезной площади квартир'
        // },
        {
            key: '5',
            name: 'м3 строительного объема'
        },
    ])
    const [analogObj, setAnalogObj] = useState(null)
    const {objectFuncTypes} = useSelector((state) => state.reObjectFunctionTypeReducer)
    const columns = [
        {
            title: 'Стоимость',
            dataIndex: 'value',
        },
        {
            title: 'Наименование',
            dataIndex: 'name',
        }
    ];


    useEffect(() => {
        if (isStatisticVisible) {
            const data = {
                id: null,
                "iso3": "ARE",
                "Стоимость": null,
                "change_in_yRate": 0,
                "object": null,
                "Наименование": null,
                code: null
            }
            const getMaxMinFromCalRlt = (calRlt) => {
                const max = Math.max(...calRlt.map(c => {
                    return c.xValue
                }))
                const min = Math.min(...calRlt.map(c => {
                    return c.xValue
                }))
                return {
                    min,
                    max
                }
            }

            const getDataRs = (calRlt) => {
                const dataRs = calRlt.map(c => {
                    data["id"] = c.id
                    data["Стоимость"] = c.xValue
                    data["change_in_yRate"] = c.change_in_yRate
                    data[code] = c.code
                    data["object"] = c.xValue
                    data["Наименование"] = c.name
                    return ({...data})
                })
                return dataRs;
            }

           const getRandomNum = ()=> Math.random() *1

            if (selectedButton === "1") {
                //серый куб - строительный объем м3
                //серый куб - строительный объем м3
                const calRlt1 = selectedRows.map(s => {
                    const xValue = Number(((s.price / s.value) * coefficient).toFixed(2))
                    return {
                        id: s.prId,
                        xValue: xValue,
                        change_in_yRate: getRandomNum(),
                        code: s.code,
                        name: s.name
                    }
                })
                const {min, max} = getMaxMinFromCalRlt(calRlt1);
                const dataRs = getDataRs(calRlt1);

                setScofig1(prev => {
                    const state = {...prev}
                    state.xAxis.max = max
                    state.xAxis.min = min
                    state.data = dataRs
                    return state
                });

                dataRs.sort((d1, d2) => {
                    return d1.object - d2.object

                })

                setSconfig2(prev => {
                    const state = {...prev}
                    state.data = dataRs
                    return state
                })

            } else if (selectedButton === "2") {
                //желтые квадраты - общая площадь квартир м2
                //желтые квадраты - общая площадь зданий м2
                const calRlt2 = selectedRows.map(s => {
                    const xValue = Number(((s.price / s.area) * coefficient).toFixed(2))
                    return {
                        id: s.prId,
                        xValue: xValue,
                        change_in_yRate: getRandomNum(),
                        code: s.code,
                        name: s.name
                    }
                })
                const {min, max} = getMaxMinFromCalRlt(calRlt2);
                const dataRs = getDataRs(calRlt2);

                setScofig1(prev => {
                    const state = {...prev}
                    state.xAxis.max = max
                    state.xAxis.min = min
                    state.data = dataRs
                    return state
                })

                dataRs.sort((d1, d2) => {
                    return d1.object - d2.object
                })
                setSconfig2(prev => {
                    const state = {...prev}
                    state.data = dataRs
                    return state
                })

            } else if (selectedButton === "3") {
                // серые квадраты - жилая (полезная) площадь квартир
                //серые квадраты - полезная площадь зданий м2
                const calRlt3 = selectedRows.map(s => {
                    const xValue = Number(((s.price / s.area2) * coefficient).toFixed(2))
                    return {
                        id: s.prId,
                        xValue: xValue,
                        change_in_yRate: getRandomNum(),
                        code: s.code,
                        name: s.name
                    }
                })
                const {min, max} = getMaxMinFromCalRlt(calRlt3);
                const dataRs = getDataRs(calRlt3);

                setScofig1(prev => {
                    const state = {...prev}
                    state.xAxis.max = max
                    state.xAxis.min = min
                    state.data = dataRs
                    return state
                })

                dataRs.sort((d1, d2) => {
                    return d1.object - d2.object
                })
                setSconfig2(prev => {
                    const state = {...prev}
                    state.data = dataRs
                    return state
                });

            } else if (selectedButton === "4") {
                // фиолетовые квадраты - мощность
                // фиолетовые квадраты - мощность
                const calRlt4 = selectedRows.map(s => {
                    const xValue = Number(((s.price / s.power) * coefficient).toFixed(2))
                    return {
                        id: s.prId,
                        xValue: xValue,
                        change_in_yRate: getRandomNum(),
                        code: s.code,
                        name: s.name
                    }
                })

                const {min, max} = getMaxMinFromCalRlt(calRlt4);
                const dataRs = getDataRs(calRlt4);

                setScofig1(prev => {
                    const state = {...prev}
                    state.xAxis.max = max
                    state.xAxis.min = min
                    state.data = dataRs
                    return state
                })

                dataRs.sort((d1, d2) => {
                    return d1.object - d2.object
                })
                setSconfig2(prev => {
                    const state = {...prev}
                    state.data = dataRs
                    return state
                });
            }
        }
    }, [selectedButton, isStatisticVisible])

    useEffect(() => {
        (async _ => {
            if (isStatisticVisible) {
                const params = {
                    ids: selectedRows.map(s => {
                        return s.id
                    })
                }
                const res = await api.postAnalogObjStatisticData(params)
                const endName = (stateFuncType.code1 !== "1" && stateFuncType.code2 !== "10") ? "здания" : "квартир"
                let data = [
                    {
                        key: '1',
                        name: `м2 общей площади ${endName}`,
                        value: res.area ? Number(res.area.toFixed(2)) : null
                    },
                    {
                        key: '2',
                        name: `м2 полезной площади ${endName}`,
                        value: res.area2 ? Number(res.area2.toFixed(2)) : null
                    },
                    {
                        key: '5',
                        name: 'м3 строительного объема',
                        value: res.value ? Number(res.value.toFixed(2)) : null
                    }
                ];
                setBuildingData(data)
            }

        })()

    }, [isStatisticVisible, selectedRows])

    const onChangeSwitch = (checked) => {
        setIsScatterOrTable(checked)
    }


    return (
        <div className='statistic-modal-div'>
            <Modal
                className="statistic-modal"
                destroyOnHidden
                footer={[]}
                title={`Статистика объектов-аналогов`}
                open={isStatisticVisible}
                onCancel={() => {
                    setIsStatisticVisible(false)
                    setIsScatterOrTable(true)
                    setSelectedButton("1")
                }}
            >


                <div className="body-modal-div">
                    <div className="group-buttons-div">
                        <Row>
                            {/*<Radio.Group value={selectedButton} onChange={(e) => setSelectedButton(e.target.value)}>*/}
                            {/*</Radio.Group>*/}
                            <Col span={6}>
                                {/*<Radio.Button className="sp-mLodal-button" value="1"><img alt=""*/}
                                {/*    src={'Frame 1.svg'}/></Radio.Button>*/}
                                <Button className="sp-modal-button" type={selectedButton === "1" ? "primary" : null}
                                        onClick={() => {
                                            setSelectedButton("1")
                                        }}><img alt="" src={'/Frame 1.svg'}/>
                                </Button>
                            </Col>
                            <Col span={6}>
                                {/*<Radio.Button className="sp-mLodal-button" value="2"><img alt=""*/}
                                {/*    src={'Frame 2.svg'}/></Radio.Button>*/}
                                <Button className="sp-modal-button" type={selectedButton === "2" ? "primary" : null}
                                        onClick={() => {
                                            setSelectedButton("2")
                                        }}><img alt="" src={'/Frame 2.svg'}/></Button>
                            </Col>
                            <Col span={6}>
                                {/*<Radio.Button className="sp-mLodal-button" value="3"><img alt=""*/}
                                {/*    src={'Frame 3.svg'}/></Radio.Button>*/}
                                <Button className="sp-modal-button" type={selectedButton === "3" ? "primary" : null}
                                        onClick={() => {
                                            setSelectedButton("3")
                                        }}><img alt="" src={'/Frame 3.svg'}/></Button>
                            </Col>
                            <Col span={6}>
                                {/*<Radio.Button className="sp-modal-button" value="4"><img alt=""*/}
                                {/*    src={'Frame 4.svg'}/></Radio.Button>*/}
                                <Button className="sp-modal-button" type={selectedButton === "4" ? "primary" : null}
                                        onClick={() => {
                                            setSelectedButton("4")
                                        }}><img alt="" src={'/Frame 4.svg'}/></Button>
                            </Col>

                        </Row>


                    </div>

                    <diiv className="statistic-table-div">
                        <Table
                            columns={columns}
                            dataSource={buildingData}
                            pagination={false}
                            size="small"/>
                    </diiv>

                    <div className="slider_for_scale_or_table">
                        <Switch
                            checkedChildren="Шкала распределения"
                            unCheckedChildren="Столбцы распределения"
                            onChange={onChangeSwitch}
                            defaultChecked
                        />
                    </div>
                    <div className="charter-div">
                        <h3>{isScatterOrTable ? "Шкала" : "Столбцы"} распределения
                            ({selectedButton === "1" ? "строительный объем м3" :
                                selectedButton === "2" ? (stateFuncType.code1 === "1" && stateFuncType.code2 === "10") ? "общая площадь квартир м2" : "общая площадь зданий м2"
                                    : selectedButton === "3" ? (stateFuncType.code1 === "1" && stateFuncType.code2 === "10") ? "жилая (полезная) площадь квартир" : "полезная площадь зданий м2"
                                        : selectedButton === "4" ? "мощность" : null
                            })</h3>
                        {
                            isScatterOrTable ?
                                <>
                                    <Scatter className="scatter-comp" {...Sconfig1} />
                                </>
                                :
                                <>
                                    <Column className="column-comp" {...Sconfig2} />
                                </>
                        }
                    </div>


                </div>
            </Modal>
        </div>

    )
}
export default StatisticModal
